import React from "react";

const SvgBigCircle = props => (
  <svg
    style={{
      isolation: "isolate"
    }}
    viewBox="0 0 205 200"
    {...props}
  >
    <defs>
      <clipPath id="BigCircle_svg__a">
        <path d="M0 0h205v200H0z" />
      </clipPath>
    </defs>
    <g clipPath="url(#BigCircle_svg__a)">
      <circle
        cx={68.43}
        cy={70.43}
        r={64.43}
        fill="#FFF"
        strokeWidth={4}
        stroke="#1D1D1B"
        strokeMiterlimit={10}
      />
    </g>
  </svg>
);

export default SvgBigCircle;